export default __webpack_public_path__ + "151a530fc45f59b9e62659d348286e03.png";